"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateProficiencyFadeCoefficient = calculateProficiencyFadeCoefficient;
exports.default = calculateProficiencyFade;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPACING_FACTOR = 4;
var SPACING_EXP_CONST = 1.4;
var MINS_IN_DAY = 60 * 24;

function calculateProficiencyFadeCoefficient(spacing, lastStudied, currentTime, logError) {
  var studyGap = (0, _moment2.default)(currentTime).diff((0, _moment2.default)(lastStudied), "minutes");

  var t = transformTime(studyGap);
  var s = transformSpacing(spacing);

  var incorrectValues = [];
  isNotAValidNumber(t) && incorrectValues.push({ label: "transformedTime", value: t });
  isNotAValidNumber(s) && incorrectValues.push({ label: "transformedSpacing", value: s });
  if (incorrectValues.length > 0) {
    logInvalidNumbers(logError, incorrectValues, {
      spacing: spacing,
      lastStudied: lastStudied,
      currentTime: currentTime,
      transformedTime: t,
      transformedSpacing: s
    });
  }

  if (isNotAValidNumber(t) || isNotAValidNumber(s)) {
    return 1;
  }

  return Math.exp(-(t / s));
}

function calculateProficiencyFade(proficiency, spacing, lastStudied, currentTime, logError) {
  var p = proficiency;

  if (isNotAValidNumber(p) || p < 0) {
    logInvalidNumbers(logError, [{ label: "proficiency", value: p }], {
      proficiency: proficiency,
      spacing: spacing,
      lastStudied: lastStudied,
      currentTime: currentTime
    });
  }

  if (isNotAValidNumber(p) || p < 0) {
    return 0;
  }

  return p * calculateProficiencyFadeCoefficient(spacing, lastStudied, currentTime, logError);
}

var transformTime = function transformTime(minutes) {
  return minutes / MINS_IN_DAY;
};

var transformSpacing = function transformSpacing(s) {
  return SPACING_FACTOR * Math.exp(Math.pow(s, SPACING_EXP_CONST));
};

function isNotAValidNumber(n) {
  return n === undefined || n === null || isNaN(n) || n === Infinity || n === -Infinity;
}

function logInvalidNumbers(logError, incorrectValues, meta) {
  logError && logError("calculateProficiencyFade recieved/calculated incorrect values, " + incorrectValues.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return label + ": " + value;
  }).join(", "), (0, _utils.convertToLogObject)(meta));
}